import { render, staticRenderFns } from "./SlimContainerWithTopMargin.vue?vue&type=template&id=421505fd&scoped=true&"
import script from "./SlimContainerWithTopMargin.vue?vue&type=script&lang=js&"
export * from "./SlimContainerWithTopMargin.vue?vue&type=script&lang=js&"
import style0 from "./SlimContainerWithTopMargin.vue?vue&type=style&index=0&id=421505fd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421505fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421505fd')) {
      api.createRecord('421505fd', component.options)
    } else {
      api.reload('421505fd', component.options)
    }
    module.hot.accept("./SlimContainerWithTopMargin.vue?vue&type=template&id=421505fd&scoped=true&", function () {
      api.rerender('421505fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/wrappers/SlimContainerWithTopMargin.vue"
export default component.exports